import React, {PropTypes as T} from 'react';
import Button from '../../../common/button';
import PasswordBox from '../../passwordbox';
import translate from '../../../../utils/translate';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

export default class PasswordProtectedPriceType extends React.Component {
  static propTypes = {
    id: T.string,
    eventId: T.string,
    priceType: T.shape({
      name: T.string.isRequired,
      code: T.string.isRequired,
      isPasswordProtected: T.bool,
      unlockingErrors: T.object,
      additionalInfo: T.array
    }),
    price: T.shape({
      priceFormatted: T.string
    }),
    isUnlockingPriceType: T.oneOfType([T.bool, T.number])
  };

  state = {
    passwordBoxVisible: false
  };

  showPasswordBox = () => {
    this.setState({ passwordBoxVisible: true });
  };

  render () {
    const {priceType, eventId, isUnlockingPriceType} = this.props;
    return (
      <div>
        <div
          className="ismmodal__option"
          onClick={this.showPasswordBox}
          tabIndex="0"
          role="button"
          data-component="password-protected-pricetype">
          <div className="ismmodal__option__label">
            <h3 className="ismmodal__option__label__title">{priceType.name}</h3>
          </div>
          <div className="ismmodal__option__control">
            <ReactCSSTransitionGroup
              transitionName="unlock-pricetype-button-transition"
              transitionEnter={false}
              transitionLeaveTimeout={250}>
              {
                !this.state.passwordBoxVisible &&
                <Button primary outlined flex
                  className="ismmodal__option__btn--unlock"
                  data-component="unlock-pricetype-button">
                  {translate('ismModule', 'UNLOCK')}
                </Button>
              }
            </ReactCSSTransitionGroup>
          </div>
        </div>
        <ReactCSSTransitionGroup
          transitionName="passwordBox__transition"
          transitionEnterTimeout={400}
          transitionLeaveTimeout={400}>
          {
            this.state.passwordBoxVisible &&
            <PasswordBox
              key="passwordbox"
              priceType={priceType}
              eventId={eventId}
              isUnlockingPriceType={isUnlockingPriceType} />
          }
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/pricetypeselector/pricetype/password_protected_pricetype.js